export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    const { likeBetter, beverageLikeBetter, feelBloated } = this.formValues

    this.showButton = !!(likeBetter && beverageLikeBetter && feelBloated)
  },
})
